import PropTypes from "prop-types";
import React from "react";

import { AnimateSvg } from "../AnimateSvg";
import { transitionPropTypes } from "../Transition";
import { graphics } from "./graphics";

/**
 * Graphic renders a predefined SVG. Only the SVG definitions in graphics.js can be rendered.
 *
 * In  addition to rendering the SVG, Graphic exposes the Transition component's props so the graphic
 * can be transformed and animated. I.E. the whole graphic can be rotated.
 *
 * Additionally, properties in the graphic can be transformed and animated via svgElementProps. E.G.
 * the stroke size of the graphic's SVG element can be transformed and animated.
 */
export const Graphic = (props) => {
  const { animate, className, initial, name, style, svgElementProps, transition } = props;
  const graphic = graphics[name];

  return <AnimateSvg {...getProps()} />;

  function getProps() {
    const { element } = graphic;

    return {
      animate: { ...graphic.animate, ...animate },
      className,
      element,
      initial: { ...graphic.svgProps, ...initial },
      style: { ...graphic.style, ...style },
      svgElementProps: {
        ...graphic.svgElementProps,
        ...svgElementProps,
        animate: { ...svgElementProps?.animate },
        initial: { ...svgElementProps?.initial },
        transition: { ...svgElementProps?.transition },
      },
      transition: { ...graphic.transition, ...transition },
    };
  }
};

Graphic.propTypes = {
  /** Values to transition. See Transition component for more information. */
  animate: transitionPropTypes.animate,

  /** Additional classes for positioning the component. */
  className: PropTypes.string,

  /** Values to transition. See Transition component for more information. */
  initial: transitionPropTypes.initial,

  /** Name of graphic defined in graphics.js. */
  name: PropTypes.string.isRequired,

  /** This object provides a way to add CSS values in addition to the properties that will be transformed. */
  style: PropTypes.object,

  /** Any props that would apply to SVG elements like path or circle. */
  svgElementProps: PropTypes.object,

  /** Values to transition. See Transition component for more information. */
  transition: transitionPropTypes.transition,
};
